import React from 'react';
import { Checkbox } from 'antd';

const CsvForm = ({
  isDateGroupBy,
  isDateSplitBy,
  isSplit,
  csvState,
  changeState,
  isTotal,
  isAvg,
  isShowPeriods,
}) => {
  return (
    <div style={{ width: 'max-content' }}>
      <div>
        <Checkbox
          nameCheckbox="additionalHeader"
          checked={csvState.additionalHeader}
          onChange={changeState}
        >
          Extra header
        </Checkbox>
      </div>
      {isDateGroupBy ? (
        <div>
          <div>
            <Checkbox
              nameCheckbox="groupByDay"
              checked={csvState.groupByDay}
              onChange={changeState}
            >
              Date (YYYY-MM-DD)
            </Checkbox>
          </div>
          <div>
            <Checkbox nameCheckbox="groupByMs" checked={csvState.groupByMs} onChange={changeState}>
              Date (ms)
            </Checkbox>
          </div>
        </div>
      ) : (
        <div>
          <Checkbox nameCheckbox="groupBy" checked={csvState.groupBy} onChange={changeState}>
            Group by
          </Checkbox>
        </div>
      )}

      {isDateSplitBy && (
        <div>
          <div>
            <Checkbox
              nameCheckbox="splitByDay"
              checked={csvState.splitByDay}
              onChange={changeState}
            >
              Split by (YYYY-MM-DD)
            </Checkbox>
          </div>
          <div>
            <Checkbox nameCheckbox="splitByMs" checked={csvState.splitByMs} onChange={changeState}>
              Split by (ms)
            </Checkbox>
          </div>
        </div>
      )}
      {isSplit && (
        <div>
          <Checkbox nameCheckbox="splitBy" checked={csvState.splitBy} onChange={changeState}>
            Split by
          </Checkbox>
        </div>
      )}
      <Checkbox nameCheckbox="count" checked={csvState.count} onChange={changeState}>
        Count
      </Checkbox>

      {isTotal && (
        <div>
          <div>
            <Checkbox nameCheckbox="sum" checked={csvState.sum} onChange={changeState}>
              Total
            </Checkbox>
          </div>
          <div>
            <Checkbox nameCheckbox="max" checked={csvState.max} onChange={changeState}>
              Max
            </Checkbox>
          </div>
          <div>
            <Checkbox nameCheckbox="min" checked={csvState.min} onChange={changeState}>
              Min
            </Checkbox>
          </div>
        </div>
      )}
      {isAvg && (
        <div>
          <Checkbox nameCheckbox="avg" checked={csvState.avg} onChange={changeState}>
            Avg
          </Checkbox>
        </div>
      )}
      {isShowPeriods && (
        <div>
          <Checkbox nameCheckbox="periods" checked={csvState.periods} onChange={changeState}>
            Periods
          </Checkbox>
        </div>
      )}
    </div>
  );
};

export default CsvForm;
